<template>
  <el-dialog
    :title="title"
    :visible="visible"
    append-to-body
    width="70%"
    @close="handleClose"
  >
    <div
      style="display: flex; align-items: center; margin-bottom: 30px"
      v-for="(item, index) in SettingsList"
      :key="index"
    >
      <div style="font-weight: bold; margin-right: 10px; margin-bottom: 5px">
        {{ item.label }}
      </div>
      <el-radio-group v-model="SettingsValue[item.value].all">
        <el-radio :label="false">所有人</el-radio>
        <el-radio :label="true">指定角色/人</el-radio>
      </el-radio-group>

      <div style="margin-left: 20px">
        <div>
          <div
            v-for="(specialItem, specialIndex) in SettingsValue[item.value]
              .specialCaseList"
            :key="specialIndex"
            style="display: inline-block; margin-right: 10px"
          >
            <el-tag
              closable
              @close="
                SettingsValue[item.value].specialCaseList.splice(
                  specialIndex,
                  1,
                )
              "
              >{{ specialItem.name }}</el-tag
            >
          </div>
        </div>
        <el-button
          type="text"
          size="default"
          @click="handleSpecialCaseSetting(SettingsValue[item.value])"
          v-if="SettingsValue[item.value].all"
          >选择</el-button
        >
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getOauth2AccessToken } from "@/api/factory.js";
const TOKEN_KEY = "Oauth2-AccessToken";
export default {
  name: "SubmissionCategoryDialog",
  props: {
    title: { type: String, default: "权限管理" },
    visible: { type: Boolean, default: false },
    // categoryOptions: { type: Array, default: () => [] },
    // initialManualList: { type: Array, default: () => [] },
    // initialOnlineList: { type: Array, default: () => [] },
  },
  data() {
    return {
      manualListInner: [],
      onlineListInner: [],
      SettingsList: [
        { label: "发起电子签约", value: "initiate_electronic_signing" },
        { label: "发起补充协议", value: "initiate_supplementary_agreement" },
        { label: "取消合同", value: "cancel_contract" },
        { label: "作废合同", value: "void_contract" },
      ],
      SettingsValue: {
        initiate_electronic_signing: {
          specialCaseList: [],
          all: false,
        },
        initiate_supplementary_agreement: {
          specialCaseList: [],
          all: false,
        },
        cancel_contract: {
          specialCaseList: [],
          all: false,
        },
        void_contract: {
          specialCaseList: [],
          all: false,
        },
      },
    };
  },
  computed: {
    // 用户选择的iframe URL
    userSelectedIframeUrl() {
      const accessToken = getOauth2AccessToken();
      return `${process.env.DESIGN_QUOTATION_PATH}/activity/userSelection?${TOKEN_KEY}=${accessToken}`;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleConfirm() {
      this.$emit("confirm", {
        manualList: this.manualListInner,
        onlineList: this.onlineListInner,
      });
    },
    handleSpecialCaseSetting(row) {
      const iframe = document.createElement("iframe");
      iframe.src = this.userSelectedIframeUrl;
      iframe.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
        z-index: 9999;
      `;
      // 监听消息
      const handleMessage = (event) => {
        const { type, data } = event.data || {};

        if (type === "USER_SELECTION_READY") {
          iframe.contentWindow.postMessage(
            {
              type: "OPEN_USER_SELECTION",
              params: [],
              params: {
                selectedUser: (row.specialCaseList || []).map((item) => ({
                  userId: item.id,
                  userName: item.name,
                })),
                orgSelectable: false, // 只允许选择人员，不允许选择组织
              },
            },
            "*",
          );
        } else if (type === "USER_SELECTED") {
          if (data) {
            row.specialCaseList = (data.selectedUser || []).map((item) => ({
              id: item.userId,
              name: item.userName,
            }));
          }
          // 关闭 iframe
          document.body.removeChild(iframe);
          window.removeEventListener("message", handleMessage);
        }
      };

      window.addEventListener("message", handleMessage);

      // 添加到页面
      document.body.appendChild(iframe);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// permissionSettings.vue?7590daf9